import { defineStore } from 'pinia'

export const useStore = defineStore('main',{
  state: () => ({
    // 定义你的状态
  }),
  getters: {
    // 定义你的 getters
  },
  actions: {
    // 定义你的 actions
  },
  // 可以定义模块
})